module.exports = "<div class=details-tab-inner> {%= primaryAccountInformation %} {%= shippingAccountInformation %} {%= billingAccountInformation %} <div class=q-section> <div class=q-marg-all-xl> <a href=# class=\"base-btn middle-btn purple-btn block-btn q-text-center submit-btn\"> Submit </a> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/maintainRetailer/html/reviewTab.html
// module id = 1343
// module chunks = 1